"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_js_1 = require("crypto-js");
var OAuth2 = /** @class */ (function () {
    function OAuth2(config, httpService, browserStorage) {
        this.config = config;
        this.httpService = httpService;
        this.browserStorage = browserStorage;
        this.storageKeyUserAuthToken = 'user_token';
        this.storageKeyUserAuthTime = 'user_time';
        this.storageKeyAnonymousAuthToken = 'anonymous_token';
        this.storageKeyAnonymousAuthTime = 'anonymous_time';
        this.cookieSessionKey = 'sess';
        this.daysToExpiration = 90;
    }
    OAuth2.prototype.getAccessTokenByClientCredentials = function () {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestBody = {
                            client_id: this.config.clientId,
                            client_secret: this.config.clientSecret,
                            grant_type: 'client_credentials',
                            scope: this.config.scopes.join(' ')
                        };
                        return [4 /*yield*/, this.httpRequestAccessToken(requestBody, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.getAccessTokenByAuthorizationCode = function (authorizationCode) {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestBody = {
                            client_id: this.config.clientId,
                            client_secret: this.config.clientSecret,
                            code: authorizationCode,
                            grant_type: 'authorization_code',
                            scope: this.config.scopes.join(' '),
                            redirect_uri: this.config.redirectUri
                        };
                        return [4 /*yield*/, this.httpRequestAccessToken(requestBody)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.getAccessTokenByPassword = function (username, password) {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestBody = {
                            client_id: this.config.clientId,
                            client_secret: this.config.clientSecret,
                            grant_type: 'password',
                            scope: this.config.scopes.join(' '),
                            redirect_uri: this.config.redirectUri,
                            username: username,
                            password: password
                        };
                        return [4 /*yield*/, this.httpRequestAccessToken(requestBody)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.updateToken = function (refreshToken) {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestBody = {
                            client_id: this.config.clientId,
                            client_secret: this.config.clientSecret,
                            grant_type: 'refresh_token',
                            scope: this.config.scopes.join(' '),
                            refresh_token: refreshToken
                        };
                        return [4 /*yield*/, this.httpRequestAccessToken(requestBody)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.httpRequestAccessToken = function (body, anonymous) {
        if (anonymous === void 0) { anonymous = false; }
        return __awaiter(this, void 0, Promise, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.httpService.post(this.config.host + "/token", body, {})];
                    case 1:
                        response = _a.sent();
                        this.saveTokenDataToStorage(response.data, anonymous);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        // @ts-ignore
                        if (error_1.response.status >= 400 && error_1.response.status < 500) {
                            anonymous ? this.destroyAnonymousTokenStored() : this.destroyUserTokenStored();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.saveTokenDataToStorage = function (tokenData, anonymous) {
        var authTime = new Date().getTime() + (Number(tokenData.expires_in) * 1000);
        this.browserStorage.setPersistLevelSession(anonymous)
            .set(anonymous ? this.storageKeyAnonymousAuthToken : this.storageKeyUserAuthToken, tokenData, true);
        this.browserStorage.setPersistLevelSession(anonymous)
            .set(anonymous ? this.storageKeyAnonymousAuthTime : this.storageKeyUserAuthTime, authTime);
    };
    OAuth2.prototype.destroyUserTokenStored = function () {
        this.browserStorage.removeCookie(this.cookieSessionKey);
        this.browserStorage.setPersistLevelSession(false).remove(this.storageKeyUserAuthTime);
        this.browserStorage.setPersistLevelSession(false).remove(this.storageKeyUserAuthToken);
    };
    OAuth2.prototype.destroyAnonymousTokenStored = function () {
        this.browserStorage.setPersistLevelSession(true).remove(this.storageKeyAnonymousAuthTime);
        this.browserStorage.setPersistLevelSession(true).remove(this.storageKeyAnonymousAuthToken);
    };
    OAuth2.prototype.createClientSessionId = function (username) {
        return crypto_js_1.MD5(username).toString(crypto_js_1.enc.Hex);
    };
    OAuth2.prototype.setSessionId = function (clientSessionId, persist) {
        if (persist === void 0) { persist = false; }
        var expires = persist ? this.daysToExpiration : undefined;
        this.browserStorage.setCookie(this.cookieSessionKey, clientSessionId, expires);
    };
    OAuth2.prototype.authenticateByPassword = function (username, password, remember) {
        if (remember === void 0) { remember = false; }
        return __awaiter(this, void 0, Promise, function () {
            var clientSessionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessTokenByPassword(username, password)];
                    case 1:
                        _a.sent();
                        clientSessionId = this.createClientSessionId(username);
                        this.setSessionId(clientSessionId, remember);
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.authenticateByCode = function (authorizationCode, clientSessionId, remember) {
        if (remember === void 0) { remember = false; }
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessTokenByAuthorizationCode(authorizationCode)];
                    case 1:
                        _a.sent();
                        this.setSessionId(clientSessionId);
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.getAnonymousTokenData = function () {
        return __awaiter(this, void 0, Promise, function () {
            var tokenData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenData = this.browserStorage.setPersistLevelSession(true).get(this.storageKeyAnonymousAuthToken, true);
                        if (!(tokenData === null || this.isExpired(true))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAccessTokenByClientCredentials()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.browserStorage.setPersistLevelSession(true).get(this.storageKeyAnonymousAuthToken, true)];
                }
            });
        });
    };
    OAuth2.prototype.getUserTokenData = function () {
        return __awaiter(this, void 0, Promise, function () {
            var tokenData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenData = this.browserStorage.setPersistLevelSession(false).get(this.storageKeyUserAuthToken, true);
                        if (tokenData === null || !this.getSessionId()) {
                            this.destroyUserTokenStored();
                            return [2 /*return*/, null];
                        }
                        if (!this.isExpired(false)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateToken(tokenData.refresh_token)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.browserStorage.setPersistLevelSession(false).get(this.storageKeyUserAuthToken, true)];
                }
            });
        });
    };
    OAuth2.prototype.setUserTokenData = function (tokenData) {
        this.saveTokenDataToStorage(tokenData, false);
    };
    OAuth2.prototype.isExpired = function (anonymous) {
        var lastAuthTime = this.browserStorage.setPersistLevelSession(anonymous).get(anonymous ? this.storageKeyAnonymousAuthTime : this.storageKeyUserAuthTime);
        return new Date().getTime() > lastAuthTime;
    };
    OAuth2.prototype.logout = function () {
        return __awaiter(this, void 0, Promise, function () {
            var tokenData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserTokenData()];
                    case 1:
                        tokenData = _a.sent();
                        if (tokenData === null) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, 5, 6]);
                        return [4 /*yield*/, this.httpService.post(this.config.host + "/logout", {}, { Authorization: "Bearer " + tokenData.access_token })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        throw error_2;
                    case 5:
                        this.destroyUserTokenStored();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2.prototype.getSessionId = function () {
        return this.browserStorage.getCookie(this.cookieSessionKey);
    };
    return OAuth2;
}());
exports.default = OAuth2;
